import { createSlice } from "@reduxjs/toolkit";

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    loading: false,
    data: null,
    customer: null,
    error: null,
    vipActiveConfigurations: null,
  },
  reducers: {
    getCustomerRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getCustomerSuccess: (state, action) => {
      state.loading = false;
      state.customer = action.payload?.data?.customer || null;
    },
    getCustomerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateCustomerRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateCustomerSuccess: (state) => {
      state.loading = false;
    },
    updateCustomerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateKycDetailsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateKycDetailsSuccess: (state) => {
      state.loading = false;
    },
    updateKycDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getVipActiveConfigurationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getVipActiveConfigurationsSuccess: (state, action) => {
      state.loading = false;
      state.vipActiveConfigurations = action.payload.data || null;
    },
    getVipActiveConfigurationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.vipActiveConfigurations = null;
    },
  },
});

export const {
  updateCustomerRequest,
  updateCustomerSuccess,
  updateCustomerFailure,
  getCustomerRequest,
  getCustomerSuccess,
  getCustomerFailure,
  updateKycDetailsRequest,
  updateKycDetailsSuccess,
  updateKycDetailsFailure,
  getVipActiveConfigurationsRequest,
  getVipActiveConfigurationsSuccess,
  getVipActiveConfigurationsFailure,
} = profileSlice.actions;

export default profileSlice.reducer;
